// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon svg {\n    margin-bottom: -20px;\n    height: 1em;\n    width: 1em;\n}\n.jp-tags__contentmenu {\n    position: fixed;\n    width: 150px;\n    background-color: #fff;\n    z-index: 2024;\n    border-radius: 5px;\n    -webkit-box-shadow: 1px 2px 10px #ccc;\n    box-shadow: 1px 2px 10px #ccc;\n}\n.jp-navbar__menu .el-badge__content.is-fixed {\n    top: 15px;\n}\n.overflow{\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
